module.exports = __webpack_public_path__ + "img/download_12.a6e0073d.png";